export interface IUtilsDict {
  [key: string]: string;
}

export class UserProfile {
  readonly username: string;
  readonly name: string;
  readonly roles: string[];
  readonly isAdmin: boolean;

  readonly utils: string[];
  readonly utilsDict: IUtilsDict = {};
  readonly token: string;

  constructor(username: string, name: string, roles: string[], utils: string[], token: string) {
    this.username = username;
    this.name = name;
    this.roles = roles || [];

    this.utils = utils || [];
    this.utils.forEach((x) => {
      this.utilsDict[x] = x;
    });

    this.isAdmin = roles.includes('Admin');
    this.token = token;
  }
}
